import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../network/API";
import { phpClient } from "../../../network";
import { getCachedData, setCachedData } from "../../../utils/storageCache";

// Cache key and duration constants
const PAYPERIOD_CACHE_KEY = 'payperiod_data';
const PAYPERIOD_CACHE_DURATION = 15 * 60 * 1000; // 15 minutes in milliseconds

export const getPayperiods = createAsyncThunk("/payperiods/all", async (data: {}, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    // Check cache first
    const cachedData = getCachedData<any>(PAYPERIOD_CACHE_KEY, PAYPERIOD_CACHE_DURATION);
    if (cachedData) {
      return cachedData.data;
    }

    // If no cache or expired, make the API call
    const response = await phpClient.get({
      url: "/account/payperiods"
    });

    // Cache the response
    if (response) {
      setCachedData(PAYPERIOD_CACHE_KEY, response);
    }

    return response;
  } catch (error) {
    console.error("*** getPayPeriods API error", error);
    return rejectWithValue(error);
  }
});

export const getPayperiod = createAsyncThunk(
  "/payperiods/single",
  async (
    data: {
      payperiod_id?: string;
      refDate?: string,
      payroll_id?: string,
      count?: number,
      employee_id?: string,     
    },
    thunkAPI
  ) => {
    const { rejectWithValue } = thunkAPI;

    const cacheKey = `${PAYPERIOD_CACHE_KEY}_${data.employee_id}_${data.count}`;

    try {
      // Check cache first
      const cachedData = getCachedData<any>(cacheKey, PAYPERIOD_CACHE_DURATION);
      if (cachedData) {
        return cachedData.data;
      }

      // If no cache or expired, make the API call
      const response = await phpClient.post({
        url: "/account/get_payperiod",
        data
      });

      // Cache the response
      if (response) {
        setCachedData(cacheKey, response);
      }

      return response;
    } catch (error) {
      console.error("*** getPayPeriod API error", error);
      return rejectWithValue(error);
    }
  });
